import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>About Siddhi Wig</h3>
          <p>
            We provide premium quality wigs, hair patches, and hairpieces for
            people seeking perfect hair solutions. Our products are carefully
            selected for quality and durability.
          </p>
        </div>
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/privacy">Privacy Policy</Link>
            </li>
            <li>
              <a href="tel:+919876543210">Contact Us</a>
            </li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>Contact Info</h3>
          <p>
            <strong>Email:</strong>{" "}
            <a href="mailto:info@siddhiwig.com">info@siddhiwig.com</a>
          </p>
          <p>
            <strong>Phone:</strong>{" "}
            <a href="tel:+919876543210">+91 98765 43210</a>
          </p>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2026 Siddhi Wig. All rights reserved.</p>
      </div>
    </footer>
  );
}
